import { LinkHandler } from "./ts/components/handlers/linkHandler";
import { NotificationService } from "./ts/services/notificationService";
import onArticle from "@hooks/onArticle";
import onArticleSeries from "@hooks/onArticleSeries";
import onCategory from "@hooks/onCategory";
import onTag from "@hooks/onTag";
import onHome from "@hooks/onHome";
import onMainInit from "@hooks/onMainInit";
import onLogin from "@hooks/onLogin";
import onUserPage from "@hooks/onUserPage";
import onUserModule from "@hooks/onUserModule";
/**
 * Page-type → hook mapping.
 * To add a new page type, create a hook file in projects/<id>/ui/hooks/
 * or ui/src/hooks/ and register it here.
 */
const PAGE_HOOKS = {
    ARTICLE: onArticle,
    ARTICLE_SERIES: onArticleSeries,
    CATEGORY: onCategory,
    TAG: onTag,
    HOME: onHome,
    LOGIN: onLogin,
    USER_PAGE: onUserPage,
    STATIC_PAGE: onUserPage,
};
// Function to initialize the application
async function initialize() {
    var _a;
    try {
        const pageType = document.body.dataset.pageType;
        const currentArticleId = (_a = document.querySelector("article")) === null || _a === void 0 ? void 0 : _a.dataset.id;
        const context = { pageType, currentArticleId };
        /** делаем ссылки кликабельными */
        new LinkHandler().init();
        // Всегда монтируем islands user module (например navbar) один раз на всех страницах.
        await onUserModule(context);
        // Выполняем хук для конкретного типа страницы, если он существует
        if (pageType && PAGE_HOOKS[pageType]) {
            await PAGE_HOOKS[pageType](context);
        }
        await onMainInit(context);
        document.dispatchEvent(new CustomEvent("mainLoaded"));
    }
    catch (e) {
        handleError(e);
    }
}
// Check if the document is already loaded
if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // Run immediately
    initialize();
}
else {
    // Wait for DOMContentLoaded
    document.addEventListener('DOMContentLoaded', initialize);
}
function handleError(e) {
    if (e instanceof Error) {
        NotificationService.reportException("index", e);
    }
    else {
        NotificationService.reportError("index", String(e));
    }
}
